module.exports = __webpack_public_path__ + "poppins-v5-devanagari_latin-ext_latin-600.0d49524ae3304f2876fb.woff2";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-600.woff2
// module id = ../../../../../src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-600.woff2
// module chunks = styles